module.exports = __webpack_public_path__ + "media/ecoleta-booster.cff7e9ef.mp4";